<template>
  <section class="about">
    <div class="about-content">
      <div class="about-left">
        <p class="image-title">位于广州琶洲人工智能实验港，全国首家专注台球场景的 AI 算法研发企业</p>
        <div class="feature-image">
          <img src="../assets/About/2.jpg" alt="智能台球展示" />
        </div>
      </div>

      <div class="about-right">
        <div class="vision-section">
          <h2>使命愿景</h2>
          <p class="vision-text">用科技让台球更精彩，打造智能化的未来台球体验</p>
        </div>

        <div class="contact-container">
          <div class="qr-section">
            <img src="../assets/About/1.jpg" alt="奇点桌球小程序码" class="qr-code" />
            <div class="qr-info">
              <h3>关注我们</h3>
              <p class="subtitle">公众号：奇点桌球</p>
            </div>
          </div>

          <div class="info-section">
            <div class="location">
              <span class="icon">📍</span>
              <div class="text">
                <h3>总部地址</h3>
                <p>广州市海珠区参悦大厦 A 塔</p>
              </div>
            </div>

            <div class="contact">
              <span class="icon">📞</span>
              <div class="text">
                <h3>加盟咨询</h3>
                <p>杨女士：13143693102</p>
                <p>李先生：13570409907</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>
.about {
  padding: 4rem 5%;
  background-color: #fff;
}

.about-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 4rem;
}

.about-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.image-title {
  font-size: 1.0rem;
  line-height: 1.8;
  color: #666;
}

.feature-image {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.feature-image img {
  width: 100%;
  height: auto;
  display: block;
}

.about-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem;
}

.vision-section {
  text-align: center;
}

.vision-section h2 {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1.5rem;
}

.vision-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
}

.contact-container {
  display: flex;
  align-items: flex-start;
  gap: 4rem;
  margin-top: 2rem;
}

.qr-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.qr-code {
  width: 200px;
  height: auto;
  max-width: 200px;
  border-radius: 8px;
  display: block;
}

.qr-info {
  text-align: center;
}

.qr-info h3 {
  margin: 0;
  color: #333;
  font-size: 1.2rem;
}

.qr-info .subtitle {
  color: #666;
  font-size: 0.9rem;
  margin-top: 0.3rem;
}

.info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 1rem;
}

.location, .contact {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.icon {
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.text {
  flex: 1;
}

.text h3 {
  font-size: 1.2rem;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.text p {
  margin: 0;
  color: #666;
  font-size: 1rem;
  line-height: 1.5;
}

@media (max-width: 1024px) {
  .about {
    padding: 3rem 4%;
  }

  .about-content {
    gap: 3rem;
  }

  .feature-image img {
    height: auto;
  }

  .vision-section h2 {
    font-size: 1.8rem;
  }

  .contact-container {
    gap: 3rem;
  }
}

@media (max-width: 768px) {
  .about {
    padding: 2rem 3%;
  }

  .about-content {
    flex-direction: column;
    gap: 2rem;
  }

  .about-right {
    padding: 1rem;
  }

  .feature-image img {
    height: auto;
  }

  .vision-section h2 {
    font-size: 1.6rem;
  }

  .vision-text {
    font-size: 1rem;
  }

  .contact-container {
    flex-direction: column;
    gap: 2rem;
    align-items: center;
  }

  .qr-code {
    width: 180px;
    height: auto;
    max-width: 180px;
  }

  .info-section {
    width: 100%;
    padding-top: 0;
  }

  .image-title {
    font-size: 1.1rem;
    text-align: center;
  }

  .icon {
    font-size: 20px;
    width: 20px;
    height: 20px;
  }

  .text h3 {
    font-size: 1.1rem;
  }

  .text p {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .about {
    padding: 1.5rem 2%;
  }

  .about-right {
    padding: 0.5rem;
  }

  .feature-image img {
    height: auto;
  }

  .vision-section h2 {
    font-size: 1.4rem;
  }

  .vision-text {
    font-size: 0.9rem;
  }

  .qr-code {
    width: 150px;
    height: auto;
    max-width: 150px;
  }

  .qr-info h3 {
    font-size: 1.1rem;
  }

  .qr-info .subtitle {
    font-size: 0.8rem;
  }

  .info-section {
    gap: 1.5rem;
  }

  .icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }

  .text h3 {
    font-size: 1rem;
  }

  .text p {
    font-size: 0.85rem;
  }
}
</style>
